'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowsMaximize, iconArrowsMaximizeTag } from '@ni/nimble-components/dist/esm/icons/arrows-maximize';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowsMaximize };
export { iconArrowsMaximizeTag };
export const NimbleIconArrowsMaximize = wrap(IconArrowsMaximize);